import { useMemo } from 'react'

import { Box, Grid, GridItem, Text } from '@chakra-ui/react'
import { TextWithBar } from 'src/components/TextWithBar/TextWithBar'
import { GetTrialHospitalsByOwnPermissionQuery } from 'src/lib/gql-client'

import { DashboardWidget } from '../DashboardWidget/DashboardWidget'

type TrialHospitals = GetTrialHospitalsByOwnPermissionQuery['trialHospitals']
type TrialHospital = TrialHospitals[number]

type Props = {
  mainTrialHospital: TrialHospital
  partnerHospitals: TrialHospitals
}

export const HospitalInformationWidget: React.FC<Props> = ({
  mainTrialHospital,
  partnerHospitals,
}: Props) => {
  const { mainHospitalName, partnerHospitalNames } = useMemo(() => {
    return {
      mainHospitalName: mainTrialHospital.hospital.name,
      partnerHospitalNames: partnerHospitals.map(
        hospital => hospital.hospital.name,
      ),
    }
  }, [mainTrialHospital, partnerHospitals])

  return (
    <DashboardWidget minH="auto">
      <Box h="36px">
        <TextWithBar fontWeight="bold">医療機関情報</TextWithBar>
      </Box>
      <Grid
        mt="4"
        templateColumns="140px minmax(0, 1fr)"
        rowGap="4"
        columnGap="0"
        overflow="hidden"
      >
        <GridItem>
          <Text fontWeight="bold" color="gray.600">
            実施医療機関
          </Text>
        </GridItem>
        <GridItem>
          <Text overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
            {mainHospitalName}
          </Text>
        </GridItem>
        {partnerHospitalNames.length > 0 && (
          <>
            <GridItem>
              <Text fontWeight="bold" color="gray.600">
                パートナー施設
              </Text>
            </GridItem>
            <GridItem>
              {partnerHospitalNames.map(partnerHospitalName => (
                <Text
                  key={partnerHospitalName}
                  w="full"
                  overflow="hidden"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                >
                  {partnerHospitalName}
                </Text>
              ))}
            </GridItem>
          </>
        )}
      </Grid>
    </DashboardWidget>
  )
}
